import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import track, { useTracking } from 'react-tracking';
import HelpModal from './HelpModal';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import { useOverviewTranslation } from '@/pages/CompanyReport/components/OverviewSection/hooks/useOverviewTranslation';
import { Button } from '@simplywallst/ui-core/next';

interface HelpProps {
  cyId?: string;
  title?: string;
  companyId: string;
  children?: ReactNode;
}

const Help = ({ cyId, title, children, companyId }: HelpProps) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const { trackEvent } = useTracking();
  const t = useOverviewTranslation();

  useEffect(() => {
    closeModal();
  }, [companyId]);

  const openModal = () => {
    trackEvent({
      action: 'click',
      modifier: 'help',
    });
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Button
        data-cy-id={cyId || 'help'}
        variant="outline"
        size="medium"
        onClick={openModal}
      >
        <InformationSolid />
        <span className="hidden whitespace-nowrap md:inline">
          {t('actions.help')}
        </span>
      </Button>
      {modalOpen && (
        <HelpModal title={title} onClose={closeModal}>
          {children}
        </HelpModal>
      )}
    </>
  );
};

export default track({ type: 'track' })(Help) as typeof Help;
